
import LinkIcon from '../../Icons/LinkIcon.vue'
import BookIcon from '../../Icons/BookIcon.vue'
import Icon from './Icon.vue'
import SectionLabel from "../../SectionLabel.vue";
import LoginRequired from "../../LoginRequired.vue";
import PageLinks from "../../PageLinks.vue";
import ScrollContainer from "../../ScrollContainer.vue";
import IndexItem from "../../IndexItem.vue";


export default {
    Name: 'IndexAndLinks',
    Icons: [Icon],
    components: {
        SectionLabel,
        LinkIcon,
        BookIcon,
        LoginRequired,
        PageLinks,
        ScrollContainer,
        IndexItem
    },
    props: {
        index: {
            type: Array,
            required: true
        },
        meta: {
            type: Object,
            required: true
        },
        selectedDictionary: {
            type: Object,
            required: false
        },
        isLogged: {
            type: Boolean,
            required: true
        },
        linksToShow: {
            type: Object,
            required: false,
            default: () => null
        },
    },
    watch: {
        selectedDictionary(value) {
            if (!value) {
                return
            }
            const dictionaryIndex = this.index.findIndex((i) => i.id === value.id)
            if (dictionaryIndex !== -1 && this.$refs.dictionaryScroll) {
                this.$refs.dictionaryScroll.scrollToIndex(dictionaryIndex)
            }
        }
    }
}
